










































































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

interface LeafCategory {
  name: string;
  namePath: string;
}

interface Subcategory {
  name: string;
  namePath: string;
  subcategories: LeafCategory[];
}

interface Category {
  name: string;
  subcategories: Subcategory[];
  namePath: string;
}

@Component({
  components: {
    CompaniesSwitcher,
  },
})
export default class BulkProfileCreate extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;

  categories: Category[] = [];
  selectedCategoryPaths: string[] = [];
  isDefaultProfile = false;
  profileName = "";
  currentDefaultProfile = "";
  isProfileNameInvalid = false;
  loading = false;
  private errorMessageTop = "";

  mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    this.$api.get("api/categories/all").then((result: any) => {
      this.categories = result.data;
      this.$api
        .get(`item-classification-api/v1/profiles/${this.companyId}/default`)
        .then((response) => {
          this.currentDefaultProfile = response.data.profileName;
          this.$store.commit("stopLoading");
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.currentDefaultProfile = "";
            this.$store.commit("recordError", "");
          } else {
            this.displayError(error);
          }
          this.$store.commit("stopLoading");
          this.loading = false;
        });
    });
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });
    this.$router.push({ name: "bulk_profile_new", params: params });
  }

  isSelected(namePath: string) {
    return this.selectedCategoryPaths.includes(namePath);
  }

  private onCategoryClicked(e, category: Category) {
    this.toggleCategoryPathSelection(category.namePath);
  }

  private onSubcategoryClicked(e, subcategory: Subcategory) {
    this.toggleCategoryPathSelection(subcategory.namePath);
  }

  private onLeafClicked(e, leaf: LeafCategory) {
    this.toggleCategoryPathSelection(leaf.namePath);
  }

  private toggleCategoryPathSelection(namePath: string) {
    if (this.selectedCategoryPaths.indexOf(namePath) >= 0) {
      this.selectedCategoryPaths = this.selectedCategoryPaths.filter(
        (p) => !p.startsWith(namePath)
      );
    } else {
      this.selectedCategoryPaths = [...this.selectedCategoryPaths, namePath];
    }
  }

  private saveProfile() {
    if (this.profileName === "") {
      this.isProfileNameInvalid = true;
      return;
    }
    if (
      this.isDefaultProfile &&
      this.currentDefaultProfile &&
      this.currentDefaultProfile !== ""
    ) {
      this.openDefaultDialog();
    } else {
      this.createProfile();
    }
  }

  private openDefaultDialog() {
    (this.$refs["set-default-profile"] as any).showModal();
  }

  private createProfile() {
    this.closeDefaultDialog();
    this.$store.commit("startLoading");
    const categoryPaths = this.dedupedCategoryPaths();
    this.$api
      .post(`item-classification-api/v1/profiles/${this.companyId}`, {
        categories: categoryPaths,
        profileName: this.profileName,
      })
      .then((response) => {
        if (this.isDefaultProfile) {
          this.$api
            .put(
              `item-classification-api/v1/profiles/${this.companyId}/default`,
              null,
              { params: { profileId: response.data.profileId } }
            )
            .then((res) => {
              this.redirectToProfiles();
            });
        } else {
          this.redirectToProfiles();
        }
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private redirectToProfiles() {
    this.$store.commit("stopLoading");
    this.$store.commit(
      "recordToast",
      "Classification profile successfully created!"
    );
    this.$router.replace({
      path: `/classification/${this.accountId}/${this.companyId}/profiles`,
    });
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/profiles`,
    });
  }

  private dedupedCategoryPaths() {
    const allPaths = this.selectedCategoryPaths;
    return this.selectedCategoryPaths.filter((path) => {
      return !allPaths
        .filter((p) => p !== path)
        .some((p) => p.startsWith(path) && p.length > path.length);
    });
  }

  private closeDefaultDialog() {
    (this.$refs["set-default-profile"] as any).close();
  }
}
